import React, { SVGAttributes, useState } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconRayRight: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect x="5" y="7" width="6" height="2" />
      <circle cx="3" cy="8" r="3" />
      <path
        d="M15.65,7.69l-4.21-2.81C11.25,4.75,11,4.89,11,5.11v5.62c0,0.22,0.25,0.36,0.44,0.23l4.21-2.81
	C15.82,8.04,15.82,7.8,15.65,7.69z"
      />
    </svg>
  );
};

export default IconRayRight;
